module.exports = __webpack_public_path__ + "static/media/logo2.6b2855f3.svg";